import React from "react";
import styled from "@emotion/styled";
import { Route, Switch } from "react-router-dom";
import { createBrowserHistory } from "history";
import ReactGA from "react-ga";

import { Home } from "./Home";
import { Games } from "./Games";
import { Devlogs } from "./Devlogs";
import { Team } from "./Team";
import { Footer } from "./Footer";
import { AddFriend } from "./AddFriend";
import { BattlerushPrivacyPolicy } from "./BattlerushPrivacyPolicy";
import { ActionJackPrivacyPolicy } from "./ActionJackPrivacyPolicy";
import { FunHillsPrivacyPolicy } from "./FunHillsPrivacyPolicy";
import ZupplePrivacyPolicy from "./ZupplePrivacyPolicy";
import { SandscapesPrivacyPolicy } from "./SandscapesPrivacyPolicy";

const history = createBrowserHistory();

// Initialize google analytics page view tracking
history.listen((location) => {
  ReactGA.set({ page: location.pathname }); // Update the user's current page
  ReactGA.pageview(location.pathname); // Record a pageview for the given page
});

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ContentContainer = styled.div`
  display: flex;
  width: 100%;
  height: fit-content;
  min-height: 100vh;
  padding-top: 5vh;
`;

const FooterContainer = styled.div`
  width: 100%;
  height: 60vh;
`;

export const Body: React.FC = (props) => {
  return (
    <Container>
      <ContentContainer>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/games" component={Games} />
          <Route exact path="/devlogs" component={Devlogs} />
          <Route exact path="/team" component={Team} />
          <Route path="/addFriend" component={AddFriend} />
          <Route
            exact
            path="/battlerush/privacy-policy"
            component={BattlerushPrivacyPolicy}
          />
          <Route
            exact
            path="/action-jack/privacy-policy"
            component={ActionJackPrivacyPolicy}
          />
          <Route
            exact
            path="/fun-hills/privacy-policy"
            component={FunHillsPrivacyPolicy}
          />
          <Route
            exact
            path="/zupple/privacy-policy"
            component={ZupplePrivacyPolicy}
          />
          <Route
            exact
            path="/sandscapes/privacy-policy"
            component={SandscapesPrivacyPolicy}
          />
        </Switch>
      </ContentContainer>

      <FooterContainer>
        <Footer />
      </FooterContainer>
    </Container>
  );
};
